import axiosClient from '../axiosClient';

export const getTransactions = (params) =>
  axiosClient.get('/admin/transactions', { params });

export const exportTransactions = (params) =>
  axiosClient.get('/admin/transactions/export', { params, responseType: 'blob' });
